<!-- @veltra/icons generated sha256:01acf45fd926ae12 gen:8 source:src/svg/normal/fork.svg -->
<script setup lang="ts">
defineOptions({ name: 'Fork' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16">
    <path
      fill="currentColor"
      d="M6 2.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-1v2h3a1 1 0 0 1 1 1v1h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h1V9h-7v1h1a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-3a.5.5 0 0 1 .5-.5h1V9a1 1 0 0 1 1-1h3V6h-1a.5.5 0 0 1-.5-.5zM7 5h2V3H7zm-4 6v2h2v-2zm8 0v2h2v-2z"
    />
  </svg>
</template>
